// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".submit_toolbar {\n  margin: 3%;\n}\n\n.upload_container {\n  margin: 1%;\n  border: 1px solid #9ecae1;\n  height: 100%;\n  border-radius: 10px;\n  padding: 1%;\n}\n\n.text_tsv {\n  display: block;\n  float: left;\n  padding: 0.5%;\n}\n\n.error_msg {\n  float: left;\n  color: red;\n  font-weight: bold;\n  width: 100%;\n  padding: 1%;\n}\n", ""]);
// Exports
module.exports = exports;
